(function () {
  'use strict';

  const PlaybackTab = Object.freeze({VIDEO_HISTORY: 0, VIDEO_PLAYBACK: 1}),
      TAB_CHANGE_EVENT = 'vfleets:playback:tabChange',
      ACTIVE_TAB_SESSION_KEY = 'playback:activeTab',
      VIDEO_HISTORY_ROLE = 'VPLAYER_REQMANUAL_VISUALIZAR',
      VIDEO_PLAYBACK_ROLE = 'VIDEO_PLAYBACK',
      VEHICLE_ONLINE_EVENT = 'safety:vehicle:online';

  class PlaybackCtrl {
    constructor($scope, $rootScope, $window, $location, safetyService, ServiceVfiltro, FactoryVfiltro, Keys, moment, Authenticator, FeatureHubConfigKeys, FeaturehubJsSdk) {
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.moment = moment;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.safetyService = safetyService;
      this.isVideoPlaybackRequest = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.VIDEO_PLAYBACK_REQUEST);
      this.window = $window;
      this.location = $location;
      this.rootScope = $rootScope;
      this.scope = $scope;
      this.activeTab = Number($window.sessionStorage.getItem(ACTIVE_TAB_SESSION_KEY)) || PlaybackTab.VIDEO_HISTORY;

      if (!this.isVideoPlaybackRequest) {
        this.serviceVfiltro.init(this.factoryVfiltro.get(this.getVideoPlaybackFilterConfig()))
        .then((filtro) => {
          this.filterInitializing = false;
          this.serviceVfiltro.openFiltroDetalhado = true;
          this.init(filtro);
        });
      } else {
        this.authenticator.getUser().then((user) => {
          this.user = user;
          this.activeTab = this.resolveInitialTab(user, this.activeTab);
          this.window.sessionStorage.setItem(ACTIVE_TAB_SESSION_KEY, this.activeTab);
          this.initFilterForTab(this.activeTab, user);
        });

        this.onTabChange = ({detail}) => {
          this.activeTab = detail.tab;
          this.window.sessionStorage.setItem(ACTIVE_TAB_SESSION_KEY, detail.tab);
          this.initFilterForTab(this.activeTab, this.user);
        };

        this.window.addEventListener(TAB_CHANGE_EVENT, this.onTabChange);

        this.onVehicleOnline = () => {
          const vehicleFilter = this.serviceVfiltro.filtroTopbar.find(
            f => f.key === this.keys.veiculo.name
          );
          if (vehicleFilter) {
            vehicleFilter.value.vmovOnline = true;
          }
          this.callVideoPlaybackPage(this.serviceVfiltro.filtroTopbar, this.user);
        };

        this.window.addEventListener(VEHICLE_ONLINE_EVENT, this.onVehicleOnline);

        const unregisterLocationChange = this.rootScope.$on('$locationChangeSuccess', () => {
          if (this.location.path() === '/relatorios/playback' && !this.filterInitializing) {
            if (this.isVideoPlaybackRequest) {
              this.callVideoPlaybackPage(this.serviceVfiltro.filtroTopbar, this.user);
            } else {
              this.initFilterForTab(this.activeTab, this.user);
            }
          }
        });

        this.scope.$on('$destroy', () => {
          this.window.removeEventListener(TAB_CHANGE_EVENT, this.onTabChange);
          this.window.removeEventListener(VEHICLE_ONLINE_EVENT, this.onVehicleOnline);
          unregisterLocationChange();
        });

        this.rootScope.$on('$stateChangeStart', (event, toState) => {
          if (toState.name !== 'root.playback') {
            this.window.sessionStorage.removeItem(ACTIVE_TAB_SESSION_KEY);
          }
        });
      }
    }

    resolveInitialTab(user, requestedTab) {
      const roles = user && user.permissoesSolucao || [],
          canShowVideoHistory = roles.indexOf(VIDEO_HISTORY_ROLE) !== -1,
          canShowVideoPlayback = roles.indexOf(VIDEO_PLAYBACK_ROLE) !== -1;

      if (requestedTab === PlaybackTab.VIDEO_HISTORY && !canShowVideoHistory && canShowVideoPlayback) {
        return PlaybackTab.VIDEO_PLAYBACK;
      }
      if (requestedTab === PlaybackTab.VIDEO_PLAYBACK && !canShowVideoPlayback && canShowVideoHistory) {
        return PlaybackTab.VIDEO_HISTORY;
      }
      return requestedTab;
    }

    initFilterForTab(tab, user) {
      const config = tab === PlaybackTab.VIDEO_HISTORY
        ? this.getVideoHistoryFilterConfig()
        : this.getVideoPlaybackFilterConfig();

      this.filterInitializing = true;
      this.serviceVfiltro.init(this.factoryVfiltro.get(config))
        .then((filtro) => {
          this.filterInitializing = false;
          if (this.isVideoPlaybackRequest) {
            this.callVideoPlaybackPage(filtro, user);
          } else {
            this.init(filtro);
          }
        })
        .catch(() => {
          this.filterInitializing = false;
          this.serviceVfiltro.openFiltroDetalhado = tab === PlaybackTab.VIDEO_PLAYBACK;
        });
    }

    getVideoPlaybackFilterConfig() {
      return [
        {
          key: this.keys.uo.name,
          required: true,
          order: 1
        },
        {
          key: this.keys.veiculo.name,
          required: true,
          checkVehiclesOnline: true,
          reloadCalendar: true,
          order: 2
        },
        {
          key: this.keys.dateTime.name,
          format: 'YYYY-MM-DD',
          maxDate: this.moment().endOf('day').format(),
          customAvailableDates: true,
          required: true,
          order: 3
        }
      ];
    }

    getVideoHistoryFilterConfig() {
      return [
        {
          key: this.keys.dateTime.name,
          time: true,
          maxDate: this.moment().endOf('day').format(),
          defaultValues: {
            hoje: {active: true},
            ultimos7dias: {active: true},
            ontem: {active: true}
          }
        },
        {
          key: this.keys.uo.name,
          required: true,
          order: 4
        },
        {
          key: this.keys.veiculos.name,
          required: false,
          order: 5
        },
        {
          key: this.keys.tipos.name,
          hasNivel: false,
          showEpiUnified: true,
          includeManualRequest: true
        },
        {
          key: this.keys.statusVideos.name
        }
      ];
    }

    init(filtro) {
      this.authenticator.getUser().then(user => {
        /*eslint-disable */
        const playbackPageContentElement = document.querySelector('#playback-page-content');

        const vfwcPlaybackElement = document.createElement('vfwc-playback'),
          vehicleFilter = filtro.find(f => f.key === this.keys.veiculo.name),
          dateTimeFilter = filtro.find(f => f.key === this.keys.dateTime.name);

        vfwcPlaybackElement.vehicleId = vehicleFilter && Number(vehicleFilter.value.id);
        vfwcPlaybackElement.startDate = dateTimeFilter && dateTimeFilter.value.startDate;
        vfwcPlaybackElement.endDate = dateTimeFilter && dateTimeFilter.value.endDate;
        vfwcPlaybackElement.user = user;

        playbackPageContentElement.innerHTML = '';
        playbackPageContentElement.appendChild(vfwcPlaybackElement);
        /*eslint-enable */
      });
    }

    callVideoPlaybackPage(filtro, user) {
      const isHistory = this.activeTab === PlaybackTab.VIDEO_HISTORY,
          vehicleFilter = isHistory
              ? filtro.find(f => f.key === this.keys.veiculos.name)
              : filtro.find(f => f.key === this.keys.veiculo.name),
          dateTimeFilter = filtro.find(f => f.key === this.keys.dateTime.name),
          type = filtro.find(f => f.key === this.keys.tipos.name),
          state = filtro.find(f => f.key === this.keys.statusVideos.name),
          vehicleIds = isHistory
              ? vehicleFilter && vehicleFilter.values.length > 0 && vehicleFilter.values.map(v => v.id) || null
              : vehicleFilter && [Number(vehicleFilter.value.id)],
          vehicleLabels = isHistory
              ? vehicleFilter && vehicleFilter.values.length > 0 && vehicleFilter.values.map(v => v.label) || null
              : vehicleFilter && [String(vehicleFilter.value.label)],
          appName = 'safetyApp',
          componentPath = './VideoPlaybackPage',
          componentId = 'safety-app-VideoPlayback',
          props = {
            activeTab: this.activeTab,
            vehicleIds,
            vehicleLabels,
            startDate: dateTimeFilter && dateTimeFilter.value.startDate,
            endDate: dateTimeFilter && dateTimeFilter.value.endDate,
            events: type && type.values.map(v => v.id),
            status: state && state.values.map(v => v.id),
            user,
            isVehicleOnline: !isHistory && vehicleFilter ? !!vehicleFilter.value.vmovOnline : undefined
          };
      this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
    }
  }

  angular
    .module('relatorios.videoLibrary.playback')
    .controller('PlaybackCtrl', PlaybackCtrl);
}());
